const docuviewareConfigurations = {
    CROP_PDF: 1,
    SIGNATURE: 2,
    SCAN_PDF: 3,
    UPDATE_FORM_FIELDS: 4,
    VIEW_DOCUMENT: 5,
    MARKUP_PDF: 6,
    BARCODE_RECOGNITION: 7,
    REDACT_PDF: 8,
    DIGITAL_SIGNATURE: 9,
    REMOVE_TEXT: 10,
    DIGITAL_SIGNATURE_SIMPLE: 11,
};

export default docuviewareConfigurations;